export const DeleteService = async (id, actionName) => {
  const inputData = {
    id: id,
  };
  await actionName(inputData);
};
